export const formatDatumOhneZeit = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    return date.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
};

export const formatDatum = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    return date.toLocaleString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
};

export const formatBetrag = (betrag, waehrung) => {
    if (betrag === null || betrag === undefined) return "-";
    const formatted = new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(betrag);
    return waehrung ? `${formatted} ${waehrung}` : formatted;
};

export const formatCurrencyInput = (value) => {
    if (!value) return "";

    // Jetzt entfernen wir alle verbleibenden Punkte (Tausenderpunkte)
    let cleanValue = value.replace(/\./g, "");
    // Behalte nur Ziffern und das ERSTE Komma
    cleanValue = cleanValue.replace(/[^\d,]/g, "");

    const commaIndex = cleanValue.indexOf(",");
    if (commaIndex !== -1) {
        cleanValue = cleanValue.substring(0, commaIndex + 1) +
            cleanValue.substring(commaIndex + 1).replace(/,/g, "");
    }

    let [integerPart, decimalPart] = cleanValue.split(",");

    if (integerPart.length > 18) {
        integerPart = integerPart.substring(0, 18);
    }

    if (decimalPart !== undefined) {
        decimalPart = decimalPart.substring(0, 2);
    }

    if (integerPart) {
        try {
            const num = BigInt(integerPart);
            integerPart = num.toLocaleString("de-DE");
        } catch (e) {
            // Behalte integerPart wie er ist
        }
    } else if (decimalPart !== undefined) {
        integerPart = "0";
    }

    return decimalPart !== undefined ? `${integerPart},${decimalPart}` : integerPart;
};

/**
 * Konvertiert einen formatierten Währungs-Input (z.B. "1.234,56")
 * in einen validen Zahlstring für das Backend (z.B. "1234.56").
 */
export const parseCurrencyInput = (value) => {
    if (!value) return null;
    // Entferne Tausenderpunkte und ersetze Dezimal-Komma durch Punkt
    return value.toString()
        .replace(/\./g, "")
        .replace(",", ".");
};
